import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const ExaminationPromotion = () => { 
  useEffect(() => {
    document.title = ' Examination and Promotion - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Examination and Promotion</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>Examination and Promotion</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                      <ul className="list">
                      <li> Those who absent themselves in any subject shall be considered failed in that subject and shall not be awarded any position, and shall not be re-examined. In case of grave illness, a medical certificate to the effect shall be produced.
                      </li>
                      <li> Regular periodical class-tests will be conducted in addition to the term examinations. Marks obtained in all the tests and term examinations will be taken into consideration for promotion.
                      </li>
                      <li> A pupil shall be eligible to appear in the Final Examination only if he/she has a minimum of 75% of the total attendance. The same may be applicable also for the term examinations.
                      </li>
                      <li> If anyone is found indulging in any malpractice during an examination he/she is liable to be debarred from further examinations.
                      </li>
                      <li> Criteria for a student to pass to the higher class after Final Examination shall be 45% of the aggregate marks obtained by the candidate in all the papers and examinations besides the internal assessment made by the school.
                      </li>
                      <li> The Principal is at liberty to follow strictly the ICSE/CBSE/PSEB promotion scheme for the students, when deciding to promote a student to the higher class. Result declared at the end of the year will be final and will not be reconsidered, nor will the answer paper be shown.
                      </li>
                      <li> A student who fails in two consecutive final examinations in the same class will have to leave the school.
                      </li>
                      <li> As the school is totally exempt from the RTE Act as it is being an Unaided Minority Private school, promotion of all students to higher
                      classes irrespective of the marks obtained for different subjects, (as recommended by the RTE Act, 2009) is not applicable to this school. Those who do not obtain the required marks will be detained in the same class; but not for more than two consecutive years in the same class.
                      </li>
                      <li> Those who seek admission in this school will have to accept this scheme of promotion. The decision of the school in the matter of promotion is final and irrevocable.
                      </li>
                      <li> Guardians are requested to examine the home work diary of the students to review each report from the school. It will be helpful in understanding as to why a child has not come up to the expectation. Such issues should be discussed with the subject teachers during the PTM.
                      </li>
                      <li> Promotion to a higher class depends upon: <br/>
                       <b>i) </b>  Regularity in attendance. <br/>
                       <b> ii) </b> Regularity and quality of day-to-day participation in the class.<br/>
                       <b> iii)</b> Assessment by the teachers of different subjects.<br/>
                       <b>  iv) </b> Written works and projects assigned by the subject's teachers.<br/>
                       <b> v) </b> Average Marks of the term examinations. </li>
                      </ul>
                     </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default ExaminationPromotion

